import AuthInstance from '../api/ContextInstance';

export const Auth = {
  name: "Auth",
  props: {
    permissionId: String | Array,
    to: String | Object
  },
  render() {
    const $slots = this.$slots;
    
    if ($slots.default && $slots.default[0]) {
      let hasPermission = false;

      if (this.permissionId) {
        if (Array.isArray(this.permissionId)) {
          hasPermission = this.permissionId.some(x => this.$context.hasPermission(x));
        } else {
          hasPermission = this.$context.hasPermission(this.permissionId);
        }
      } else {
        let route = this.$vnode.context.$route;
        if (this.to) {
          route = this.$router.matcher.match(this.to) 
        }

        hasPermission = !!route && AuthInstance.hasPermissionByRequiredPermissionIds(route.meta.permissionIds);

        if ((this.$vnode.data && this.$vnode.data.props && this.$vnode.data.props.readonlyDependent) || route.meta.readonlyDependent) {
          hasPermission = !AuthInstance.readonly;
        }
      }

      if (hasPermission) {
        return this.$slots.default[0];
      } 
    }
  }
};

const getAuthVNode = function(createElement, context, tag) {
  let child = createElement(
    tag,
    context.data,
    context.children
  );

  return createElement(
    'auth', {
      props: {
        permissionId: context.props.permissionId,
        to: context.props.to,
        readonlyDependent: context.props.readonlyDependent
      }
    },
    [child]
  )
}

export const AuthBLink = {
  name: "AuthBLink",
  functional: true,
  render(createElement, context) {
    return getAuthVNode(createElement, context, 'b-link');
  }
};

export const AuthBBtn = {
  name: "AuthBBtn",
  functional: true,
  render(createElement, context) {
    return getAuthVNode(createElement, context, 'b-btn');
  }
};

export const AuthBNavItem = {
  name: "AuthBNavItem",
  functional: true,
  render(createElement, context) {
    return getAuthVNode(createElement, context, 'b-nav-item');
  }
};
